import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from 'api/authConfig'

// MSAL configuration for Azure AD login
// MSAL needs to be initialized before use
export const msalInstance = new PublicClientApplication(msalConfig)
await msalInstance.initialize()
